module.exports = __webpack_public_path__ + "tenant-1-08b3ead1ccd6d3045999740db7507471.bundle.svg";